import { render, staticRenderFns } from "./btns.vue?vue&type=template&id=f21fea62&scoped=true&"
import script from "./btns.vue?vue&type=script&lang=js&"
export * from "./btns.vue?vue&type=script&lang=js&"
import style0 from "./btns.vue?vue&type=style&index=0&id=f21fea62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21fea62",
  null
  
)

export default component.exports